import React from "react";

export default function PageNotFound() {
    return (
        <div>
            <h2>Not found</h2>
        </div>
    );
}